import AttributionPage from "@/components/attribution/AttributionPage";
import { useRole } from '@/contexts/RoleContext';
import { PageTour } from "@/components/tour/PageTour";
import { attributionSteps } from "@/lib/tour-steps";

export default function ClientAttribution() {
  const { clientId } = useRole();
  return (
    <>
      <PageTour steps={attributionSteps} />
      <AttributionPage fixedClientId={clientId ?? undefined} />
    </>
  );
}
